export default __webpack_public_path__ + "static/media/marketplace-icon.719ccb4a.svg";